import { ENDPOINTS } from "@/constants/endpoints"
import { HTTP_METHODS } from "@/constants/httpMethods"
import { QUERY_KEYS } from "@/constants/queryKeys"
import { useGenereicMutation } from "@/hooks/useGenericMutation"
import type { ProfileLinks, StudentProfile } from "@/types/profileTypes"

export function useEditStudentMutation() {
  return useGenereicMutation<Omit<StudentProfile, "id">>({
    createEndpoint: () => ENDPOINTS.profile.update(),
    method: HTTP_METHODS.POST,
    invalidationKeys: [
      QUERY_KEYS.profile.show(),
      QUERY_KEYS.profile.socialLinks(),
    ],
  })
}

export function useEditSocialLinksMutation() {
  return useGenereicMutation<Omit<ProfileLinks, "user_id">>({
    createEndpoint: () => ENDPOINTS.profile.updateSocialLinks(),
    method: HTTP_METHODS.POST,
    invalidationKeys: [
      QUERY_KEYS.profile.show(),
      QUERY_KEYS.profile.socialLinks(),
    ],
  })
}
